import styled from 'styled-components/macro';
import { TextInput } from 'visits-style';
import theme from 'styles/theme';
import media from 'styles/media';

const StyledTextInput = styled(TextInput)`
  height: 40px;
  color: ${theme.textPrimary};

  /* input text */
  input {
    border: 1px solid
      ${({ error }) => (error ? theme.baseError : theme.borderDefault)};
    border-radius: 3px;
    font-size: 14px;

    &:hover,
    &:focus,
    &:active {
      border-color: ${({ error }) =>
        error ? theme.baseError : theme.borderActive};
      box-shadow: none;
    }

    &::placeholder {
      color: ${theme.borderDefault};
    }

    ${media.mobile} {
      font-size: 16px;
    }
  }

  /* error message */
  small {
    display: inline-block;
    margin-top: 4px;
    font-size: 14px;
    line-height: 1.5;

    ${media.mobile} {
      font-size: 12px;
    }
  }

  &&& {
    &:hover {
      input:not(:disabled):not(:focus):not(:active) {
        border-color: ${({ error }) =>
          error ? theme.baseError : theme.borderDefault};
      }
    }
  }
`;

export default StyledTextInput;
